import { Box, Button, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from '../../store/menuSlice'
import time from '../../assets/icons/e-learning/time.svg'
import book from '../../assets/icons/e-learning/user/book.svg'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/Loader'
import * as api from '../services/api'
import styles from './elearning.module.css'

function ManageELearning() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [search, setSearch] = useState('')
  const [optionGroup, setOptionGroup] = useState([])
  const [category, setCategory] = useState('null')
  const [courseList, setCourseList] = useState([])
  const [courseListAll, setCourseListAll] = useState([])

  useEffect(() => {
    dispatch(menuActive('จัดการ E-Learning'))
  }, [])

  useEffect(() => {
    findCourse()
  }, [])

  const handleClickSearch = () => {
    if (category === 'null') {
      if (search === '') {
        setCourseList(courseListAll)
      } else {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_name.toLowerCase().includes(search.toLowerCase())
        )
        setCourseList(filteredItems)
      }
    } else {
      if (search === '') {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_group_code.toLowerCase().includes(category.toLowerCase())
        )
        setCourseList(filteredItems)
      } else {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_name.toLowerCase().includes(search.toLowerCase()) && item.e_learning_group_code.toLowerCase().includes(category.toLowerCase())
        )
        setCourseList(filteredItems)
      }
    }

  }

  const findCourse = async () => {
    setLoading(true)
    let res = await api.findCourse()
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        let data = res['data']['data']
        setCourseList([...data].reverse())
        setCourseListAll([...data].reverse())

        let option = []
        for (let i = 0; i < data.length; i++) {
          if (data[i]) {
            option.push({
              key: data[i]['e_learning_group_code'],
              value: data[i]['e_learning_group_name']
            })
          }
          const unique = [...new Map(option.map((m) => [m.key, m])).values()]
          setOptionGroup(unique)
        }
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const handleFilterGroup = (e) => {
    let { value } = e.target
    setCategory(value)

    if (search === '') {
      if (value === 'null') {
        setCourseList(courseListAll)
      } else {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_group_code.toLowerCase().includes(value.toLowerCase())
        )
        setCourseList(filteredItems)
      }
    } else {
      if (value === 'null') {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_name.toLowerCase().includes(search.toLowerCase())
        )
        setCourseList(filteredItems)
      } else {
        const filteredItems = courseListAll.filter((item) =>
          item.e_learning_name.toLowerCase().includes(search.toLowerCase()) && item.e_learning_group_code.toLowerCase().includes(value.toLowerCase())
        )
        setCourseList(filteredItems)
      }
    }

  }

  const convertDate = (dataDate) => {
    const date = new Date(dataDate)
    const optionDate = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    const thaiLocale = 'th-TH';
    const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

    const newDate = `${formattedDate}`
    return newDate
  }

  return (
    <>
      <Loader loading={loading} />
      <Box sx={{ display: 'grid', gridGap: '10px' }}>
        <Box sx={{
          fontWeight: 600,
          color: "#478F96",
          "@media (max-width: 800px)": {
            textAlign: "center",
          },
        }}>จัดการห้องเรียนออนไลน์</Box>

        <Box sx={{
          border: '1px solid #478F96',
          borderRadius: '10px',
          display: 'flex',
          padding: '5px'
        }}>
          <TextField
            fullWidth
            variant="standard"
            sx={{
              ...InputCSS
            }}
            InputProps={{
              disableUnderline: true,
            }}
            placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
            value={search}
            onChange={(e) => { setSearch(e.target.value) }}
          />
          <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
        </Box>

        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          "@media (max-width: 800px)": {
            display: 'grid',
            gridGap: '10px',
            justifyContent: 'center'
          }
        }}>
          <Box>
            <Select
              size="small"
              sx={{ ...SelectCss }}
              value={category || "null"}
              onChange={(e) => { handleFilterGroup(e) }}
            >
              <MenuItem value="null">หมวดหมู่ทั้งหมด</MenuItem>
              {optionGroup.map((i, idx) => (
                <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
              ))}
            </Select>
          </Box>
          <Box sx={{
            "@media (max-width: 800px)": {
              display: 'grid',
              justifyContent: 'center'
            }
          }}>
            <Button
              variant='contained'
              onClick={() => { navigate('/allCategories') }}
            >หลักสูตรทั้งหมด</Button>
          </Box>
        </Box>

        <Box sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: '10px',
          "@media (max-width: 1000px)": {
            gridTemplateColumns: '1fr 1fr',
          },
          "@media (max-width: 600px)": {
            gridTemplateColumns: '1fr',
          }
        }}>
          {courseList.map((item, index) => (
            <Box sx={{
              border: '1px solid #2F327D1A',
              boxShadow: '2px 2px 10px #2F327D1A',
              backgroundColor: '#ffffff',
              borderRadius: '10px',
              padding: '10px',
              display: 'grid',
              gridGap: '5px',
              fontSize: '14px',
            }} key={index}>
              <Box sx={{
                height: '200px',
                "@media (max-width: 1000px)": {
                  height: '150px',
                }
              }}>
                <img src={item['e_learning_image']} style={{ width: '100%', borderRadius: '10px', height: 'inherit', objectFit: 'cover' }} />
              </Box>

              <Box sx={{ fontWeight: 600,fontSize: '16px' }}>{item['e_learning_name']}</Box>

              <Box><span style={{ fontWeight: 600 }}>สร้างเมื่อ :</span> {convertDate(item['created_date'])}</Box>

              <Box sx={{ display: 'flex', gridGap: '10px' }}>
                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                  <Box>
                    <img src={book} />
                  </Box>
                  <Box>{item['properties'].length} บทเรียน</Box>
                </Box>
                <Box sx={{ display: 'flex', gridGap: '5px' }}>
                  <Box>
                    <img src={time} />
                  </Box>
                  <Box>{item['e_learning_hour']} ชั่วโมง</Box>
                </Box>
              </Box>

              <Box className={styles.ellipsis}>{item['e_learning_detail']}</Box>

              <Box sx={{ display: 'flex', gridGap: '10px' }}>
                <Box sx={{ fontWeight: 600 }}>ผู้เข้าเรียน:</Box>
                <Box>{item['register_total']} คน</Box>
              </Box>
            </Box>
          ))}
        </Box>

      </Box>
    </>
  )
}

export default ManageELearning

const InputCSS = {
  padding: '5px',
  border: 'none',
  '&.MuiInputBase-root': {
    border: 'none'
  },
  '&.MuiInputBase-root:focus': {

  }
}

const SelectCss = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
}
